module.exports = __webpack_public_path__ + "img/cases-brand-herborist-lazyload-61.c821d707.jpg";